import clsx from 'clsx';
import { Formik, FormikProps } from 'formik';
import {useContext, useEffect, useRef, useState} from 'react';
import { Button, Stack } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AppContext } from 'src/app/modules/appContext/AppContext';
import FormInPhieuDialog from '../../../../../../component/button-in-phieu/components/PrintDialog';
import CustomTabMenu from '../../../../../../component/CustomTabMenu';
import { CODE, RESPONSE_MESSAGE } from 'src/app/modules/utils/Constant';
import { HO_SO_BENH_AN_FORM } from '../../../../../constants/BenhAn';
import {HoSoBenhAnContext, HoSoBenhAnContextProvider} from './context';
import {getDsTabBenhAn, printMedicalRecord, updateThongTinBenhAn, updateTypeBenhAn} from './service';
import BenhAn from './tabs/BenhAn';
import TongKetBenhAn from './tabs/TongKetBenhAn';
import TrangBia from './tabs/TrangBia';
import TrangMot from './tabs/TrangMot';
import {usePhanHeKhamBenhContext} from "../../../../../contexts/PhanHeTiepDonContext";
import PhieuLayout from '../../../shared/PhieuLayout';
import ModalLoaiBenhAn from "./components/ModalLoaiBenhAn";

const COMPONENT_FORM_KEY_MAPPER: Record<string, React.ComponentType<any>> = {
	[HO_SO_BENH_AN_FORM.TRANG_BIA]: TrangBia,
	[HO_SO_BENH_AN_FORM.TRANG_1]: TrangMot,
	[HO_SO_BENH_AN_FORM.TRANG_A]: BenhAn,
	[HO_SO_BENH_AN_FORM.TRANG_TONG_KET]: TongKetBenhAn,
};

type Props = {
	disabled?: boolean;
}

const HoSoBenhAn = ({ disabled }: Props) => {
	const { setIsLoading } = useContext(AppContext);
  const {benhNhanInfo} = usePhanHeKhamBenhContext();

	const formikRef = useRef<FormikProps<any>>(null);
	const [dsTab, setDsTab] = useState<any[]>([]);
	const [activeTab, setActiveTab] = useState(HO_SO_BENH_AN_FORM.TRANG_1);
	const [openPrintDialog, setOpenPrintDialog] = useState(false);
	const [isPrintTab, setIsPrintTab] = useState(false);
	const [openSelectType, setOpenSelectType] = useState(false);

	const isShowSaveButton = ![HO_SO_BENH_AN_FORM.TRANG_BIA].includes(activeTab);
  const benhNhanDieuTri = benhNhanInfo?.thongTinKhamBenh || {}

	const onSubmit = async (values: any) => {
		try {
			setIsLoading(true);
			const formData = getTabValue(values, activeTab);
			const { code } = await updateThongTinBenhAn(
				benhNhanDieuTri.encounterIdExec,
				activeTab,
				formData
			);

			if (CODE.SUCCESS === code) {
				toast.success('Cập nhật thông tin bệnh án thành công');
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	const getTabValue = (formValues: any, tabValue: string) => {
		if (tabValue === HO_SO_BENH_AN_FORM.TRANG_A) {
			const {
				forms,
				dacDiemLienQuanBenh,
				dacDiemLienQuanBenhResult,
				...otherValues
			} = formValues;

			return {
				...forms,
				...getDacDiemLienQuanBenhValue(dacDiemLienQuanBenh, dacDiemLienQuanBenhResult),
				...otherValues,
				diseaseDay: parseInt(forms.diseaseDay) || 0,
			};
		}

		const { forms, ...otherValues } = formValues;

		return {
			...forms,
			...otherValues,
		};
	};

	const getDacDiemLienQuanBenhValue = (value: any, initialValue: any) => {
		let result: Record<string, any> = {};

		if (value) {
			Object.entries(value).forEach(([key, value]) => {
				result[key] =
					value === '0' || !value
						? null
						: typeof value === 'boolean'
						? Number(value).toString()
						: Number(value);
			});
		} else {
			result = initialValue;
		}

		return result;
	};
	const handleSaveType = async (values: any) => {
		try {
			let data = await updateTypeBenhAn({
				encounterId: benhNhanDieuTri?.encounterIdExec,
				medicalRecordTypeCode: values?.medicalRecordType?.code,
			});
			console.log(data)
			await handleGetDsTab();
		} catch (error) {
			console.error(error);
		} finally {
			setOpenSelectType(false);
		}
	}
	const handleGetDsTab = async () => {
		try {
			let data = await getDsTabBenhAn(benhNhanDieuTri?.encounterIdExec);
			let tabs = data?.data?.map((item: any) => {
				const Component = COMPONENT_FORM_KEY_MAPPER[item?.modelType];
				return {
					eventKey: item?.modelType,
					title: item?.name,
					component: Component ? <Component {...item} /> : null,
				};
			});
			setDsTab(tabs);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		handleGetDsTab();
	}, []);

	return (
		<div className="h-100 overflow-y-auto">
			<HoSoBenhAnContextProvider>
				<HoSoBenhAnContext.Consumer>
					{({ hideAction }) => (
						<>
							<Formik initialValues={{}} onSubmit={onSubmit} innerRef={formikRef}>
								{({ submitForm, resetForm }) => (
									<PhieuLayout.Content>
									<PhieuLayout.Form>
										<CustomTabMenu
											danhsachTabs={dsTab}
											classNameTabContent="spaces px-16 py-8 pb-100"
											activeTab={activeTab}
											onTabChange={(activeTab: any) => {
												setActiveTab(activeTab);
												resetForm();
											}}
										/>
									</PhieuLayout.Form>
										<PhieuLayout.Action>
											<Stack
												direction="horizontal"
												className="spaces gap-8 w-100 justify-content-end"
											>
											<Button
												className="btn-fill"
												onClick={() => {
													setOpenSelectType(true);
												}}
											>
												Chọn loại bệnh án
											</Button>

											<Button
												className="btn-fill"
												onClick={() => {
													setIsPrintTab(true);
													setOpenPrintDialog(true);
												}}
											>
												In trang
											</Button>
											<Button
												className="btn-fill"
												onClick={() => {
													setIsPrintTab(false);
													setOpenPrintDialog(true);
												}}
											>
												In bệnh án
											</Button>

											{isShowSaveButton && !hideAction && !disabled && (
												<Button
													className="btn-fill"
													onClick={() => submitForm()}
												>
													Lưu
												</Button>
											)}
											</Stack>
										</PhieuLayout.Action>
									</PhieuLayout.Content>
								)}
							</Formik>
							{openPrintDialog && (
								<FormInPhieuDialog
									show={openPrintDialog}
									onHide={() => {
										setOpenPrintDialog(false);
									}}
									fetchExport={printMedicalRecord}
									params={{
										encounterId: benhNhanDieuTri?.encounterIdExec,
										...(isPrintTab && { form: activeTab }),
									}}
								/>
							)}
							{openSelectType && (
								<ModalLoaiBenhAn
									open={openSelectType}
									handleClose={() => setOpenSelectType(false)}
									onSave={handleSaveType}
								/>
							)}
						</>
					)}
				</HoSoBenhAnContext.Consumer>
			</HoSoBenhAnContextProvider>
		</div>
	);
};

export default HoSoBenhAn;
